import { render, staticRenderFns } from "./service-record.vue?vue&type=template&id=acee85a4&scoped=true"
import script from "./service-record.vue?vue&type=script&lang=js"
export * from "./service-record.vue?vue&type=script&lang=js"
import style0 from "./service-record.vue?vue&type=style&index=0&id=acee85a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acee85a4",
  null
  
)

export default component.exports